import '@common/common'

import { addTranslation, getLang, TRANSLATE_CHANGED_EVENT } from '@common/i18n/v1/translate'

import SVGIcon from '@common/components/SVGIcon/SVGIcon'
import ToTop   from '@common/components/ToTop/ToTop'

import Menu   from './components/Menu/Menu'
import Header from './components/Header/Header'
import Footer from './components/Footer/Footer'

import './visibilityHandler'

import './Text.scss'

import styles from './mosolyteremto.scss'

async function ready (): Promise<void> {
  const html = document.querySelector('html') as HTMLElement

  document.addEventListener(TRANSLATE_CHANGED_EVENT, () => {
    const actLang = getLang()

    html.setAttribute('lang', actLang)
  })

  await Promise.all(
    __LANGS__.map(async (lang) => {
      /** MUSZÁJ külön változóban tartani a fájlnevet, különben syntax error! */
      const fileName = `${ lang }-${ lang }.json`

      const json = await import(
        /* webpackMode: "eager" */
        /* webpackChunkName: "[request]" */
        __LOCALES__ + fileName
      )

      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      addTranslation(lang, json.default)
    })
  )

  const menu: DocumentFragment = <Menu />

  const navbar     = menu.querySelector('.sen-navbar') as HTMLElement
  const hamburger  = menu.querySelector('.sen-navbar__button[data-type="hamburger"]') as HTMLElement
  const sideMenu   = menu.querySelector('.sen-navbar__side-menu') as HTMLElement
  const sideMenuBg = menu.querySelector('.sen-navbar__side-menu-bg') as HTMLElement

  document.body.appendChild(
    <Fragment>
      <Header>
        { navbar }
      </Header>

      { hamburger }
      { sideMenu }
      { sideMenuBg }
      { /* A routing alapján ebben cserélődik a tartalom */ }
      <main id="root" className={ styles.main } />
      <Footer />

      <ToTop>
        <SVGIcon type="chevron-top" />
      </ToTop>
    </Fragment>
  )

  const { default: router } = await import(
    /* webpackChunkName: "router" */
    './router'
  )

  router.run()
}

ready()
